import styled from "styled-components";
import { THEME } from "../../styles/theme";

export const PageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TrainingContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;
  padding: 2rem;
  border-radius: 1.5rem;
  background-color: ${THEME.palette.background.paper};
  overflow-y: auto;
  flex: 1;
`;
